import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieConsentBanner from "@/components/feature/CookieConsentBanner";
import GlobalPopup from "@/components/feature/GlobalPopup";
import SeoCanonical from "@/components/feature/SeoCanonical";

function RouteFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#001416" }}>
      <div className="w-8 h-8 border-2 border-[#00C5C8] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={<RouteFallback />}>
          <AppRoutes />
        </Suspense>
        <SeoCanonical />
        <CookieConsentBanner />
        <GlobalPopup />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;